import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

/** Floating "back to top" button that fades in after the user scrolls down. */
export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          type="button"
          onClick={toTop}
          data-testid="back-to-top-btn"
          aria-label="Back to top"
          initial={{ opacity: 0, scale: 0.6, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 16 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ y: -3 }}
          className="fixed bottom-20 right-5 md:right-6 z-[55] w-12 h-12 rounded-full grid place-items-center text-white bg-gradient-to-b from-blue-400 to-blue-600 border border-white/20 shadow-[0_8px_28px_-4px_rgba(10,132,255,0.7),inset_0_1px_0_rgba(255,255,255,0.35)] backdrop-blur"
        >
          <ArrowUp className="w-5 h-5" strokeWidth={2.2} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
